import "./SupportCategories.css";
import CategoryCard from "../CategoryCard/CategoryCard";

const TEXT = {
  ar: {
    loading: "جاري تحميل أنواع الطلبات...",
    empty: "لا توجد أنواع طلبات حالياً",
  },
  en: {
    loading: "Loading request types...",
    empty: "No request types available",
  },
};

const SupportCategories = ({
  categories,
  loading,
  selectedCategory,
  onSelectCategory,
  lang = "ar",
}) => {
  const t = TEXT[lang] || TEXT.ar;

  if (loading) {
    return <div className="support-loading">{t.loading}</div>;
  }

  if (!categories?.length) {
    return <div className="support-empty">{t.empty}</div>;
  }

  return (
    <div className="support-categories-grid">
      {categories.map((category) => (
        <CategoryCard
          key={category?._id || category?.code}
          category={category}
          selected={selectedCategory?.code === category?.code}
          onClick={() => onSelectCategory(category)}
          lang={lang}
        />
      ))}
    </div>
  );
};

export default SupportCategories;